import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import DocumentsModule from './components/DocumentsModule';
import { usePartnerDocumentsView } from './context/PartnerDocumentsViewContext';

const PartnerDocumentsView: FC = () => {
  const { data } = usePartnerDocumentsView();

  return (
    <>
      <DocumentsModule isCertificatesValueSharesModule={false} />

      {data.certificateValueSharesDocuments?.length > 0 && (
        <DocumentsModule isCertificatesValueSharesModule />
      )}

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default PartnerDocumentsView;
